<template>
<div class="chapter">
<div class="inner_page">
<div id="abouttheauthor">
<h2 class="left"><i>MARGARET MOORE</i></h2>
<p class="noindent">confesses that her first “crush” was Errol Flynn. The second was “Mr. Spock.” She thinks that explains why her heroes tend to be either charming rogues or lean, inscrutable tough guys.<br/><br/></p>
<p class="noindent">Margaret lives in Scarborough, Ontario, with her husband, two children and two cats. She used to sew and read for reasons other than research.</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007-abouttheauthor.vue?3e74b556